import axios from '../axios'
// 区域列表
export const getBaseAreaPage = (data) => {
  return axios({
    url: '/api/sys/getBaseAreaPage',
    method: 'post',
    data
  })
}
//区域列表删除
export const deleteBaseAreas = data => {
  return axios({
      url: '/api/sys/deleteBaseAreas',
      method: 'post',
      data
  })
};
// 员工保存修改
export const saveBaseArea = data => {
  // 保存
  if (!data.areaId) {
    return axios({
      url: '/api/sys/saveBaseArea',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/updateBaseArea',
      method: 'post',
      data
    })
  }
}

// 区域价格本列表
export const getBasePriceAreaPage = (data) => {
  return axios({
    url: '/api/sys/base/getBasePriceAreaPage',
    method: 'post',
    data
  })
}
//区域价格本列表删除
export const deleteBasePriceAreas = data => {
  return axios({
      url: '/api/sys/base/deleteBasePriceAreas',
      method: 'post',
      data
  })
};
//区域价格本列表修改
export const updateBasePriceArea = data => {
  return axios({
      url: '/api/sys/base/updateBasePriceArea',
      method: 'post',
      data
  })
};
//区域价格本列表批量保存
export const batchSaveBasePriceArea = data => {
  return axios({
      url: '/api/sys/base/batchSaveBasePriceArea',
      method: 'post',
      data
  })
};
//区域价格本列表保存
export const saveBasePriceArea = data => {
  return axios({
      url: '/api/sys/base/saveBasePriceArea',
      method: 'post',
      data
  })
};
//区域价格本列表批量修改
export const updateBasePriceAreaBatch = data => {
  return axios({
      url: '/api/sys/base/updateBasePriceAreaBatch',
      method: 'post',
      data
  })
};
//审核区域价格本
export const auditBasePriceArea = data => {
  return axios({
      url: '/api/sys/base/auditBasePriceArea',
      method: 'post',
      data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/Region.js